import { useLayoutEffect } from 'react';

import { windowObject } from '@ctct/infrastructure-layer';
import { useAccountId } from '@ctct/state-server-layer';

let initialized = false;

export const useGoogleAnalytics = () => {
  const { data: accountId } = useAccountId();

  useLayoutEffect(() => {
    if (accountId && !initialized) {
      windowObject.initGA4(accountId.toString());
      initialized = true;
    }
  }, [accountId]);
};
